import { Injectable } from '@angular/core';
import { KHQRIMAGEDATA } from 'src/app/shared/constants/khqrimagedata.const';
declare const Buffer: any;
declare let document: any;

@Injectable({
  providedIn: 'root'
})
export class ImagesConvertorService {

  constructor(
  ) {}

  convertBase64ToBlob(images: any, isKHQR?: boolean): Promise<any> {
    const binaryBase64 = new Promise((resolve) => {
      let contentType = 'image/jpg';
      if (isKHQR) {
        contentType = 'image/png';
      }
      const b64Data = images;
      const sliceSize = 512;
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      resolve(blob);
    });

    return binaryBase64;
  }

  convertBlobToBase64(blob: any): Promise<any> {
    const base64Data = new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
    return base64Data;
  }

  convertBase64ToArrayBuffer(base64: any): Promise<any> {
    const byteImage = new Promise((resolve) => {
      const binaryString = window.atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      resolve(bytes);
    });
    return byteImage;
  }

  convertArrayBuffertoBase64(byteArr: any): Promise<any> {
    const base64Image = new Promise((resolve) => {
      const base64Buffer = new Buffer(byteArr);
      const base64ImageString = base64Buffer.toString('base64');
      resolve(base64ImageString);
    });
    return base64Image;
  }

  convertArrayBuffertoBinary(byteArr: any): Promise<any> {
    const base64Image = new Promise((resolve) => {
      const base64Buffer = new Buffer(byteArr);
      const base64ImageString = base64Buffer.toString('binary');
      resolve(base64ImageString);
    });
    return base64Image;
  }

  makeKHQRImageToBase64(base64String: string, transactionCurrencyCode: 'USD' | 'KHR', receiverName: string, merchantCode: string): Promise<any> {
    return new Promise((resolve) => {
      try {
        const canvas = document.createElement('canvas');
        const currencyQRImg = document.createElement('img');
        const backgroundImg = document.createElement('img');
        const qrImgage = document.createElement('img');
        let currencyQRImgData = KHQRIMAGEDATA.KHQR_CURRENCY_QR_USD;
        if (transactionCurrencyCode === 'KHR') {
          currencyQRImgData = KHQRIMAGEDATA.KHQR_CURRENCY_QR_KHR;
        }
        const backgroundImgKHQRTag = KHQRIMAGEDATA.KHQR_TAG30_BACKGROUND_IMAGE;
        backgroundImg.src = backgroundImgKHQRTag;
        qrImgage.src = base64String;
        currencyQRImg.src = currencyQRImgData;
        backgroundImg.onload = () => {
          const imgWidth = 1463;
          const imgHeight = 2078;
          canvas.width = imgWidth;
          canvas.height = imgHeight;
          const context = canvas.getContext('2d');
          context.fillStyle = 'black';
          context.fillRect(0, 0, imgWidth, imgHeight);
          context.drawImage(backgroundImg, 0, 0, imgWidth, imgHeight);
          context.drawImage(qrImgage, 412.5, 625, 645, 645);
          context.drawImage(currencyQRImg, 678, 888, 120, 120);
          const maxLength = 20; // maximum length of text before splitting into a new line
          const words = receiverName.split(' ');
          const lines = [];
          let currentLine = words[0];
          for (let i = 1; i < words.length; i++) {
            const word = words[i];
            if (currentLine.length + word.length < maxLength) {
              currentLine += ' ' + word;
            } else {
              lines.push(currentLine);
              currentLine = word;
            }
          }
          lines.push(currentLine);
          // Merchant Name
          if ( lines.length === 1 ) {
            context.font = 'bold 99.84975px Nunito Sans';
            const lineHeight = 100;
            const totalLines = lines.length;
            const startY = 1415 - ((totalLines - 1) * lineHeight / 2);
            for (let i = 0; i < totalLines; i++) {
              const line = lines[i];
              const textWidth = context.measureText(line).width;
              const x = (imgWidth - textWidth) / 2;
              const y = startY + i * lineHeight;
              context.fillText(line, x, y);
            }

            // Merchant Code:
            const merchantCodeWidth = context.measureText(merchantCode).width;
            const merchantWidth = (imgWidth - merchantCodeWidth) / 2;
            const merchantHeight = startY + totalLines * lineHeight - 10;
            context.font = '41.27123px  Nunito Sans';
            context.fillStyle = '##000000';
            context.fillText("   Merchant ID : " + merchantCode, merchantWidth, merchantHeight);
            context.imageSmoothingQuality = 'high';

            // Merchant Code lable:
            // const merchantIDLabelName: any = 'Merchant ID:';
            // const merchantIDLabelWidth = context.measureText(merchantIDLabelName).width;
            // const merchantLabelWidth = (imgWidth - merchantIDLabelWidth) / 2.40;
            // const merchantLabelHeight = startY + totalLines * lineHeight - 10;
            // context.font = '500 41.285335px bold Nunito Sans';
            // context.fillStyle = '##000000';
            // context.fillText(merchantIDLabelName, merchantLabelWidth, merchantLabelHeight);
            // context.imageSmoothingQuality = 'high';
          } else {
              context.font = 'bold 119.86065px Nunito Sans';
              // context.font = 'bold 119.86065px Nunito Sans';
              const lineHeight = 100;
              const totalLines = lines.length;
              const startY = 1455 - ((totalLines - 1) * lineHeight / 2);
              for (let i = 0; i < totalLines; i++) {
                const line = lines[i];
                const textWidth = context.measureText(line).width;
                const x = (imgWidth - textWidth) / 2;
                const y = startY + i * lineHeight;
                context.fillText(line, x, y);
              }

              // Merchant Code:
              const merchantCodeWidth = context.measureText(merchantCode).width;
              const merchantWidth = (imgWidth - merchantCodeWidth) / 2;
              const merchantHeight = startY + totalLines * lineHeight - 10;
              context.font = '41.285335px  Nunito Sans';
              context.fillStyle = '##000000';
              context.fillText("Merchant ID  :  " + merchantCode, merchantWidth, merchantHeight);
              context.imageSmoothingQuality = 'high';

            // Merchant Code lable:
              // const merchantIDLabelName: any = 'Merchant ID:';
              // const merchantIDLabelWidth = context.measureText(merchantIDLabelName).width;
              // const merchantLabelWidth = (imgWidth - merchantIDLabelWidth) / 2.6;
              // const merchantLabelHeight = startY + totalLines * lineHeight - 10;
              // context.font = '500 41.285335px bold Nunito Sans';
              // context.fillStyle = '##000000';
              // context.fillText(merchantIDLabelName, merchantLabelWidth, merchantLabelHeight);
              // context.imageSmoothingQuality = 'high';
          }
          context.fill();
          resolve(canvas.toDataURL());
        };
      } catch ( error ) {
      }
    });
  }
}
